var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"slot":"body"},slot:"body"},[_c('bita-form',{ref:"form"},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('div',{staticClass:"row",domProps:{"innerHTML":_vm._s(this.CompletedProfileSellerText)}})])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }